export default __webpack_public_path__ + "static/media/ico-tyquy.f69f4cb6.svg";